import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { SnLocation } from '@lib/api/entities';
import { SnLocationsAPI } from '@lib/api/services';

@Component({
  selector: 'fs-locations-resource',
  templateUrl: './locations-resource.component.html',
  styleUrls: ['./locations-resource.component.scss'],
})
export class LocationsResourceComponent implements OnInit, OnDestroy {
  @Input() public resources: any[];

  @Input() public removable: boolean;

  @Output() public readonly loadedLocations = new EventEmitter();

  @Input()
  public locations: SnLocation[];

  public isLoading: boolean = false;

  private readonly _destroy$ = new Subject();

  constructor(
    private readonly _locationsAPI: SnLocationsAPI,
    private readonly _cd: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this._loadCameras();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private _loadCameras(): void {
    if (!this.resources[0]?.location_In?.length) {
      return;
    }
    this.isLoading = true;
    this._locationsAPI
      .getLocationList({
        id__in: this.resources[0].location_In.join(','),
        pageSize: 'all',
      })
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (res) => {
          this.locations = res.results;
          this.loadedLocations.next(this.locations);
          this._cd.detectChanges();
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }
}
